import Eastern51 from '../Eastern/Grand Eastern 5 (1).webp'
import Eastern52 from '../Eastern/Grand Eastern 5 (2).webp'


const Eastern5images =[
Eastern51,Eastern52
]

export default Eastern5images;